import { render, staticRenderFns } from "./common-audiencead-add.vue?vue&type=template&id=6c7ded4d&scoped=true&"
import script from "./common-audiencead-add.vue?vue&type=script&lang=js&"
export * from "./common-audiencead-add.vue?vue&type=script&lang=js&"
import style0 from "./common-audiencead-add.vue?vue&type=style&index=0&id=6c7ded4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7ded4d",
  null
  
)

export default component.exports